import { Autocomplete, TextField } from '@mui/material';
import { SearchSelectProps } from './search-select.props';
import { InstantIcon } from '../../assets/images';

function SearchSelect({
  options,
  value,
  onChange,
  placeholder,
  // styles = {},
  disabled,
}: SearchSelectProps) {
  const selectedOption =
    options?.find((option) => option?.id === value) ||
    options?.find((option) => option?.label?.toLowerCase() === value?.toString().toLowerCase());
  // const selectedOption = options?.find((option) => option.id === value);
  return (
    <Autocomplete
      disablePortal
      options={options}
      value={selectedOption || null}
      onChange={(_, selectedOptionVal) => onChange(selectedOptionVal?.id as string)}
      getOptionLabel={(option) => option.label ?? ''}
      sx={{
        width: '100%',
        '& .MuiAutocomplete-inputRoot': {
          paddingTop: '4px',
          paddingBottom: '1px',
        },
      }}
      renderOption={(props, option) => (
        <li
          {...props}
          className="border border-[#E5E7EB] bg-[#F7F9FB] m-2 rounded-lg cursor-pointer thin-scroller"
        >
          <div className="py-2 px-3 w-full thin-scroller">
            <div className="flex items-center thin-scroller">
              <span style={{ fontWeight: 'bold' }}>{option.label}</span>
              <img src={InstantIcon} alt="instant-icon" className="ml-1" />
            </div>
            <p style={{ fontSize: '12px', color: '#777' }}>{option.description}</p>
          </div>
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={placeholder}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '0.5rem',
            },
          }}
        />
      )}
      disabled={disabled}
    />
  );
}

export default SearchSelect;
